import React from "react";
import "./Events.css";
import clock from "../../Assets/vectors/Icons/clock.svg";
import date from "../../Assets/vectors/Icons/date.svg";
import parent_meet from "../../Assets/events/parents_meeting.jpg";
import sports_day from "../../Assets/events/sports_prize_giving.jpg";
import new_campus from "../../Assets/events/new_campus.jpg";
import award_cer from "../../Assets/events/cam_cer_awa_cer.jpg";

export default function Events() {
  return (
    <div className="events">
      <h3>Events</h3>
      <h1>Recent Events & Affairs</h1>
      <div className="grid gridFr eventsContainer">
        <div className="card">
          <img className="greyScale" src={parent_meet} alt="" />
          <div className="container">
            <h2>Annual Parent Meeting</h2>
            <div className="timeTable">
              <img src={date} alt="" />
              <span>19 February 2019</span>
            </div>

            <div className="timeTable">
              <img src={clock} alt="" />
              <span>12:00 am - 2:00 pm</span>
            </div>
          </div>
        </div>
        <div className="card ">
          <img className="greyScale" src={award_cer} alt="" />
          <div className="container">
            <h2>Award Ceremony</h2>
            <div className="timeTable">
              <img src={date} alt="" />
              <span>19 February 2018</span>
            </div>
            <div className="timeTable">
              <img src={clock} alt="" />
              <span>12:00 am - 2:00 pm </span>
            </div>
          </div>
        </div>
        <div className="card ">
          <img className="greyScale" src={sports_day} alt="" />
          <div className="container">
            <h2>Creative & Sports Day</h2>
            <div className="timeTable">
              <img src={date} alt="" />
              <span>11 April 2017</span>
            </div>
            <div className="timeTable">
              <img src={clock} alt="" />
              <span>12:00 am - 2:00 pm</span>
            </div>
          </div>
        </div>
        <div className="card ">
          <img className="greyScale" src={new_campus} alt="" />
          <div className="container">
            <h2>New Campus Event</h2>
            <div className="timeTable">
              <img src={date} alt="" />
              <span>30 August 2016</span>
            </div>
            <div className="timeTable">
              <img src={clock} alt="" />
              <span>12:00 am - 2:00 pm </span>
            </div>
          </div>
        </div>
      </div>
      <div
        className="flex"
        style={{ justifyContent: "center", marginTop: "3rem" }}
      >
        <button className="bt ripple" style={{ width: "160px" }}>
          View More Events
        </button>
      </div>
    </div>
  );
}
